import "./Footer.css";
import FooterItems from "./FooterItems";
import SocialMedia from "./SocialMedia";
const Footer = () => {
  return (
    <div className="fotter">
        <SocialMedia/>
        <FooterItems/>
    </div>
  );
};

export default Footer;
